<div class="promotion-page">
  <div class="sm:hidden mx:block" style="background: white; margin-bottom: 10px;">
    <customer-select class="customer-selector" style="display: flex; justify-content: end; background: white;
        border-bottom: 1px solid black;"></customer-select>
  </div>
  <section class="hero">
    <div class="hero-carousel">
      <div class="hero-track">
        <!-- Loading State -->
        <div class="hero-loading" *ngIf="heroLoading">
          <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
          <p>加载中...</p>
        </div>
        <!-- Empty State -->
        <div class="hero-slide hero-slide--empty" [class.active]="!heroLoading && activityList.length === 0"
          [class.hero-slide--sizing]="heroLoading">
          <div class="hero-top">
            <div class="hero-left">
              <p class="hero-kicker">限时促销</p>
              <h1>暂无活动</h1>
              <div class="hero-meta">
                <span class="activity-time">更多精彩活动敬请期待</span>
              </div>
              <button nz-button nzType="primary" class="join-btn" disabled>立即参与</button>
            </div>
            <div class="hero-image hero-image--empty">
              <i nz-icon nzType="gift" nzTheme="outline" class="hero-empty-icon"></i>
            </div>
          </div>
          <div class="hero-bottom-bar">
            <div class="progress-section">
              <div class="progress-header">
                <span class="progress-label">下一张赠券进度</span>
                <span class="progress-values">0 / 0</span>
              </div>
              <nz-progress [nzPercent]="0" [nzShowInfo]="false" [nzStrokeColor]="'#ffcf00'"></nz-progress>
              <p class="progress-tip">当前无活动进度，暂无待解锁奖励</p>
            </div>
            <div class="stats-section">
              <div class="stat-item">
                <i nz-icon nzType="gift" nzTheme="outline"></i>
                <span>已获赠券: <strong>0</strong> 张</span>
              </div>
              <div class="stat-item">
                <i nz-icon nzType="check-circle" nzTheme="outline"></i>
                <span>已核销: <strong>0</strong> 张</span>
              </div>
              <button nz-button class="redeem-btn" disabled>去兑换卡券</button>
            </div>
          </div>
        </div>
        <!-- Activity Slides -->
        <div class="hero-slide" *ngFor="let activity of activityList; let i = index" [class.active]="!heroLoading && i === activeSlideIndex">
          <div class="hero-top">
            <div class="hero-left">
              <p class="hero-kicker">限时促销</p>
              <h1>{{ activity.activityName }}</h1>
              <div class="hero-meta">
                <span class="activity-time">活动时间：{{ formatTimeRangePublic(activity.startTime, activity.endTime) }}</span>
                <i nz-icon nzType="info-circle" nzTheme="outline" class="info-icon" (click)="openDisclaimer(activity)"></i>
              </div>
              <button nz-button nzType="primary" class="join-btn" (click)="onJoinActivity(activity)">立即参与</button>
            </div>
            <div class="hero-image">
              <img *ngIf="getAwardImageUrl(activity) && !awardImgBroken.has(activity.activityId)"
                   [src]="getAwardImageUrl(activity)" [alt]="activity.activityName" (error)="onAwardImageError(activity)" />
              <ng-container *ngIf="!getAwardImageUrl(activity) || awardImgBroken.has(activity.activityId)">
                <i nz-icon nzType="gift" nzTheme="outline" class="hero-empty-icon"></i>
              </ng-container>
            </div>
          </div>
          <div class="hero-bottom-bar">
            <div class="progress-section">
              <div class="progress-header">
                <span class="progress-label">下一张赠券进度</span>
                <span class="progress-values">{{ formatDisplayValue(activity.progressCurrent, activity.baselineType) }} / {{ formatDisplayValue(activity.progressTarget, activity.baselineType) }} {{ activity.baselineType === 'By Qty' ? 'EA' : 'CNY' }}</span>
              </div>
              <nz-progress [nzPercent]="calcProgressRate(activity)" [nzShowInfo]="false" [nzStrokeColor]="'#ffcf00'"></nz-progress>
              <p class="progress-tip">
                <ng-container *ngIf="activity.progressTarget > 0; else noProgressTip">
                  <ng-container *ngIf="activity.progressRemaining > 0; else achievedTip">再买 <span class="remaining-amount">{{ formatDisplayValue(activity.progressRemaining, activity.baselineType) }} {{ activity.baselineType === 'By Qty' ? 'EA' : 'CNY' }}</span> 即可解锁</ng-container>
                  <ng-template #achievedTip>目标已达成</ng-template>
                </ng-container>
                <ng-template #noProgressTip>当前无活动进度，暂无待解锁奖励</ng-template>
              </p>
            </div>
            <div class="stats-section">
              <div class="stat-item">
                <i nz-icon nzType="gift" nzTheme="outline"></i>
                <span>已获赠券: <strong>{{ activity.issuedAwardQty ?? 0 }}</strong> 张</span>
              </div>
              <div class="stat-item">
                <i nz-icon nzType="check-circle" nzTheme="outline"></i>
                <span>已核销: <strong>{{ activity.redeemedAwardQty ?? 0 }}</strong> 张</span>
              </div>
              <a class="redemption-detail-link" *ngIf="(activity.redeemedAwardQty ?? 0) > 0" (click)="openRedemptionDetail(activity)">
                <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                <span>核销详情</span>
              </a>
              <button nz-button class="redeem-btn" (click)="openRedeemModal()">去兑换卡券</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hero-dots" *ngIf="activityList.length > 1">
      <!-- Left Arrow -->
      <button class="carousel-arrow carousel-arrow--left" (click)="prevSlide()">
        <i nz-icon nzType="left" nzTheme="outline"></i>
      </button>
      <span
        class="hero-dot"
        *ngFor="let activity of activityList; let i = index"
        [class.active]="i === activeSlideIndex"
        (click)="goToSlide(i)">
      </span>
      <!-- Right Arrow -->
      <button class="carousel-arrow carousel-arrow--right" (click)="nextSlide()">
        <i nz-icon nzType="right" nzTheme="outline"></i>
      </button>
    </div>
  </section>

  <section class="filter-bar">
    <div class="status-tabs">
      <button type="button" class="status-tab" [class.active]="statusFilter === 'ongoing'" (click)="onStatusFilterChange('ongoing')">进行中</button>
      <button type="button" class="status-tab" [class.active]="statusFilter === 'upcoming'" (click)="onStatusFilterChange('upcoming')">即将上线</button>
      <button type="button" class="status-tab" [class.active]="statusFilter === 'ended'" (click)="onStatusFilterChange('ended')">已结束</button>
      <div class="search-area" *ngIf="statusFilter !== 'ended'">
        <nz-input-group [nzPrefix]="prefixIcon" class="search-input">
          <input type="text" nz-input placeholder="搜索产品10位料号" [(ngModel)]="searchKeyword" (keyup.enter)="onSearch()" />
        </nz-input-group>
        <ng-template #prefixIcon><i nz-icon nzType="search" class="search-icon" (click)="onSearch()"></i></ng-template>
      </div>
      <!-- 已结束筛选区：仅展示搜索活动名称 -->
      <div class="search-area" *ngIf="statusFilter === 'ended'">
        <nz-input-group [nzPrefix]="endedPrefixIcon" class="search-input">
          <input type="text" nz-input placeholder="搜索活动名称" [(ngModel)]="searchKeyword" (keyup.enter)="onSearch()" />
        </nz-input-group>
        <ng-template #endedPrefixIcon><i nz-icon nzType="search" class="search-icon" (click)="onSearch()"></i></ng-template>
      </div>
    </div>
  </section>

  <!-- 第二行 filter bar：所有活动 + 按 activityStatus 过滤后的活动名称 -->
  <section class="activity-filter-bar" #activityFilterBar
    *ngIf="statusFilter !== 'ended' && activitiesForCurrentStatus.length > 0">
    <div class="activity-tabs">
      <div class="activity-tabs__list">
        <button type="button" class="activity-tab"
          [class.active]="joinedActivityId === null"
          (click)="onClearActivity()">所有活动</button>
        <button type="button" class="activity-tab"
          *ngFor="let act of visibleActivityTabs; trackBy: trackByActivityId"
          [class.active]="joinedActivityId === act.activityId"
          [title]="act.activityName"
          (click)="onSelectActivityFilter(act)">
          <span class="activity-tab__name">{{ act.activityName }}</span>
        </button>
        <span class="activity-tabs__more" *ngIf="hasMoreActivityTabs" title="更多活动">···</span>
      </div>
      <button type="button" class="activity-all-dropdown"
        nz-dropdown nzTrigger="click" [nzDropdownMenu]="allActivitiesMenu" nzPlacement="bottomRight">
        <span class="activity-all-dropdown__label">活动列表</span>
        <i nz-icon nzType="down" nzTheme="outline" class="activity-all-dropdown__arrow"></i>
      </button>
      <nz-dropdown-menu #allActivitiesMenu="nzDropdownMenu">
        <ul nz-menu class="activity-all-menu">
          <li nz-menu-item *ngFor="let act of activitiesForCurrentStatus; trackBy: trackByActivityId"
            [nzSelected]="joinedActivityId === act.activityId"
            [title]="act.activityName"
            (click)="onSelectActivityFilter(act)">
            <span class="activity-all-menu__name">{{ act.activityName }}</span>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
  </section>

  <!-- 已结束活动列表：数据来自 /promotion/front/history/activity-summary -->
  <section class="ended-section" *ngIf="statusFilter === 'ended'">
    <div class="ended-summary">
      <h3 class="ended-summary__title">历史活动汇总摘要</h3>
      <div class="ended-summary__metrics">
        <div class="metric">
          <span class="metric-label">累计获得奖励汇总</span>
          <div class="metric-value-row">
            <span class="metric-divider"></span>
            <span class="metric-value">{{ endedSummary.totalEarned | number }}</span>
          </div>
        </div>
        <div class="metric-separator"></div>
        <div class="metric">
          <span class="metric-label">已兑换数量汇总</span>
          <div class="metric-value-row">
            <span class="metric-divider"></span>
            <span class="metric-value">{{ endedSummary.totalRedeemed | number }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-spinner" *ngIf="endedLoading">
      <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
      <p>加载历史活动中...</p>
    </div>

    <div class="ended-list" *ngIf="!endedLoading && endedActivities.length > 0">
      <article class="ended-card" *ngFor="let item of endedActivities">
        <div class="ended-card__main">
          <h4 class="ended-card__name">{{ item.activityName }}</h4>
          <p class="ended-card__meta">活动时间：{{ formatTimeRangePublic(item.startTime, item.endTime) }}</p>
          <p class="ended-card__meta">活动内容：{{ item.activityContents }}</p>
        </div>
        <div class="ended-card__side">
          <div class="ended-stat">
            <div class="ended-stat__top">
              <i nz-icon nzType="gift" nzTheme="outline"></i>
              <span class="ended-stat__label">已获奖励</span>
            </div>
            <span class="ended-stat__value">{{ item.earnedAwardLabel }}</span>
          </div>
          <div class="ended-stat">
            <div class="ended-stat__top">
              <i nz-icon nzType="check-circle" nzTheme="outline"></i>
              <span class="ended-stat__label">已兑换数量</span>
            </div>
            <span class="ended-stat__value">{{ item.redeemedQty | number }}</span>
          </div>
          <div class="ended-stat" [class.is-disabled]="!item.canViewRedemption">
            <div class="ended-stat__top">
              <i nz-icon nzType="info-circle" nzTheme="outline"></i>
              <span class="ended-stat__label">核销详情</span>
            </div>
            <a class="ended-stat__link" (click)="openRedemptionDetail(item)">查看详情</a>
          </div>
          <button nz-button class="ended-redeem-btn" [disabled]="!item.canRedeem" (click)="openRedeemModal()">
            <span>去兑换</span>
            <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
          </button>
        </div>
      </article>
    </div>

    <!-- 已结束列表滚动加载哨兵（与产品列表复用 #scrollSentinel 引用，仅 ended tab 下渲染） -->
    <div #scrollSentinel class="scroll-sentinel"
      *ngIf="endedActivities.length > 0"
      [class.loading]="endedLoadingMore">
      <div class="load-more-indicator" *ngIf="endedLoadingMore">
        <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
        <span>正在加载更多...</span>
      </div>
    </div>

    <!-- 已结束活动空状态 -->
    <div class="product-empty-state" *ngIf="!endedLoading && endedActivities.length === 0">
      <i nz-icon nzType="inbox" nzTheme="outline" class="empty-icon"></i>
      <p class="empty-title">暂无已结束的活动</p>
      <p class="empty-subtitle">活动结束后可在这里查看历史奖励与兑换情况</p>
    </div>
  </section>

  <section class="product-grid" *ngIf="statusFilter !== 'ended' && (products.length > 0 || loadingMore)">
    <article class="product-card" *ngFor="let product of products" (click)="goDetail(product)">
      <!-- <div class="product-badge" [ngClass]="product.statusType">{{ product.status }}</div> -->
      <div class="product-image-placeholder">
        <img *ngIf="product.imageUrl" [src]="product.imageUrl" [alt]="product.title" class="product-image" />
      </div>
      <div class="product-info">
        <p class="product-category">{{ product.category }}</p>
        <h3>{{ product.title }}</h3>
        <p class="meta">物料号: {{ product.materialNo }}</p>
        <p class="meta">起订量: {{ product.minOrderQty }}</p>
        <p class="desc">{{ product.description }}</p>
      </div>
      <div class="card-action" (click)="$event.stopPropagation()">
        <quantity-input
          mode="list"
          [(quantity)]="product.quantity"
        ></quantity-input>
        <button nz-button nzType="primary" class="cart-btn" (click)="onAddToCart(product)">
          <i nz-icon nzType="shopping-cart" nzTheme="outline"></i>
        </button>
        <!-- <button nz-button nzType="default" class="remind-btn" *ngIf="product.status === '暂无库存'">
          <i nz-icon nzType="bell" nzTheme="outline"></i>
          暂无库存
        </button> -->
      </div>
    </article>
  </section>

  <!-- 产品列表空状态 -->
  <div class="product-empty-state" *ngIf="statusFilter !== 'ended' && !productsLoading && products.length === 0">
    <i nz-icon nzType="inbox" nzTheme="outline" class="empty-icon"></i>
    <ng-container *ngIf="isSearchingByPartNo; else browseEmpty">
      <p class="empty-title">没有匹配到结果</p>
      <p class="empty-subtitle">请检查 10 位料号是否正确</p>
    </ng-container>
    <ng-template #browseEmpty>
      <p class="empty-title">{{ statusFilter === 'upcoming' ? '暂时没有即将上线的活动' : '暂时没有进行中的活动' }}</p>
      <p class="empty-subtitle">请稍后再来查看新活动</p>
    </ng-template>
  </div>

  <!-- 初始加载 spinner -->
  <div class="loading-spinner" *ngIf="productsLoading && products.length === 0">
    <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
    <p>{{ isSearchingByPartNo ? '正在搜索产品...' : '加载促销产品中...' }}</p>
  </div>

  <!-- 滚动加载哨兵：与产品列表展示条件保持一致，切到其他 tab / 无产品时自动取消展示 -->
  <div #scrollSentinel class="scroll-sentinel"
    *ngIf="statusFilter !== 'ended' && (products.length > 0 || loadingMore)"
    [class.loading]="loadingMore">
    <div class="load-more-indicator" *ngIf="loadingMore">
      <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
      <span>正在加载更多...</span>
    </div>
  </div>
</div>

<!-- 兑换流程弹窗 -->
<nz-modal
  [(nzVisible)]="redeemModalVisible"
  nzTitle="兑换流程"
  [nzFooter]="null"
  [nzWidth]="520"
  nzCentered
  nzClassName="redeem-process-modal"
  (nzOnCancel)="redeemModalVisible = false"
>
  <ng-container *nzModalContent>
    <div class="redeem-modal-content">
      <!-- 二维码 -->
      <img
        class="redeem-qr-image"
        src="assets/images/1210_BCP_WEB.jpg"
        alt="eXtra 兑换二维码"
      />
      <div class="redeem-qr-label">扫描二维码</div>
      <div class="redeem-qr-sublabel">(博世易加积分兑换平台)</div>

      <!-- 兑换流程图片，点击放大 -->
      <div class="redeem-process-section">
        <div>兑换流程</div>
        <div class="redeem-process-divider"></div>
        <img
          class="redeem-process-image"
          src="assets/promotion/redemption-process.png"
          alt="兑换流程"
          title="点击放大"
          (click)="openProcessPreview()"
        />
      </div>
    </div>
  </ng-container>
</nz-modal>

<!-- 兑换流程图片放大弹窗 -->
<nz-modal
  [(nzVisible)]="processPreviewVisible"
  [nzFooter]="null"
  [nzWidth]="'90%'"
  nzCentered
  nzClassName="redeem-process-preview-modal"
  (nzOnCancel)="closeProcessPreview()"
>
  <ng-container *nzModalContent>
    <div class="redeem-process-preview">
      <div
        class="preview-viewport"
        title="滚轮缩放，放大后可拖拽平移"
        (wheel)="onPreviewWheel($event)"
        (mousedown)="onPreviewDragStart($event)"
        (mousemove)="onPreviewDragMove($event)"
        (mouseup)="onPreviewDragEnd()"
        (mouseleave)="onPreviewDragEnd()"
      >
        <img
          src="assets/promotion/redemption-process.png"
          alt="兑换流程"
          draggable="false"
          [ngStyle]="previewImageStyle"
        />
      </div>
      <div class="preview-toolbar">
        <button
          nz-button
          nzType="default"
          nzSize="small"
          title="缩小"
          [disabled]="previewZoom <= PREVIEW_ZOOM_MIN"
          (click)="previewZoomOut()"
        >
          <span nz-icon nzType="zoom-out" nzTheme="outline"></span>
        </button>
        <span class="preview-zoom-label">{{ (previewZoom * 100) | number:'1.0-0' }}%</span>
        <button
          nz-button
          nzType="default"
          nzSize="small"
          title="放大"
          [disabled]="previewZoom >= PREVIEW_ZOOM_MAX"
          (click)="previewZoomIn()"
        >
          <span nz-icon nzType="zoom-in" nzTheme="outline"></span>
        </button>
        <button
          nz-button
          nzType="link"
          nzSize="small"
          [disabled]="previewZoom <= PREVIEW_ZOOM_MIN"
          (click)="resetPreviewTransform()"
        >重置</button>
      </div>
    </div>
  </ng-container>
</nz-modal>

<!-- 核销详情弹窗 -->
<nz-modal
  [(nzVisible)]="redemptionModalVisible"
  nzTitle="核销详情"
  [nzFooter]="redemptionFooter"
  [nzWidth]="680"
  nzCentered
  nzClassName="promotion-detail-modal"
  (nzOnCancel)="redemptionModalVisible = false"
>
  <ng-container *nzModalContent>
    <nz-table
      #redemptionTable
      [nzData]="redemptionDetails"
      [nzLoading]="redemptionLoading"
      [nzShowPagination]="false"
      nzSize="middle"
    >
      <thead>
        <tr>
          <th>卡券编码</th>
          <th>订单编码</th>
          <th>订单状态</th>
          <th>物流编码</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of redemptionTable.data">
          <td>{{ row.voucherCode }}</td>
          <td>{{ row.orderCode }}</td>
          <td><span [class.status-shipped]="row.orderStatus === '已发货'">{{ row.orderStatus }}</span></td>
          <td>{{ row.logisticsCode || '-' }}</td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>
  <ng-template #redemptionFooter>
    <div class="redemption-footer">
      <button nz-button nzType="primary" (click)="redemptionModalVisible = false">关闭</button>
    </div>
  </ng-template>
</nz-modal>

<!-- 活动说明弹窗 -->
<nz-modal
  [(nzVisible)]="disclaimerModalVisible"
  nzTitle="活动说明"
  [nzFooter]="disclaimerFooter"
  [nzWidth]="520"
  nzCentered
  nzClassName="promotion-detail-modal"
  (nzOnCancel)="disclaimerModalVisible = false"
>
  <ng-container *nzModalContent>
    <p class="disclaimer-text">* {{ currentDisclaimer }}</p>
  </ng-container>
  <ng-template #disclaimerFooter>
    <div class="redemption-footer">
      <button nz-button nzType="primary" (click)="disclaimerModalVisible = false">确认</button>
    </div>
  </ng-template>
</nz-modal>
